import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { field, index, table } from '@tencent/memoire-structured-storage';
import PathUtils from '../utils/path-utils';
import BlobBaseModel from './blob-base-model';
var BlobMetadataModel = /** @class */ (function (_super) {
    __extends(BlobMetadataModel, _super);
    function BlobMetadataModel(_a) {
        var path = _a.path, namespace = _a.namespace, type = _a.type, createdAt = _a.createdAt, updatedAt = _a.updatedAt, size = _a.size, additions = _a.additions;
        var _this = _super.call(this, { path: path, namespace: namespace, type: type }) || this;
        _this.createdAt = createdAt;
        _this.updatedAt = updatedAt;
        _this.size = size;
        _this.additions = additions;
        return _this;
    }
    BlobMetadataModel.fromBlob = function (path, blob, additions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new this({
                        namespace: PathUtils.namespace(path),
                        path: PathUtils.normalize(path),
                        type: blob.type,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                        size: blob.size,
                        additions: additions,
                    })];
            });
        });
    };
    BlobMetadataModel.prototype.setAdditions = function (additions) {
        this.additions = additions;
        this.updatedAt = new Date();
        return this;
    };
    __decorate([
        index()
    ], BlobMetadataModel.prototype, "createdAt", void 0);
    __decorate([
        index()
    ], BlobMetadataModel.prototype, "updatedAt", void 0);
    __decorate([
        field()
    ], BlobMetadataModel.prototype, "size", void 0);
    __decorate([
        field()
    ], BlobMetadataModel.prototype, "additions", void 0);
    BlobMetadataModel = __decorate([
        table('BlobMetadata')
    ], BlobMetadataModel);
    return BlobMetadataModel;
}(BlobBaseModel));
export default BlobMetadataModel;
//# sourceMappingURL=blob-metadata-model.js.map